// // --- Helper Functions (Vanilla JS equivalents of jQuery methods) ---

// /**
//  * Toggles the display of an element with a slide-up/slide-down animation.
//  * @param {HTMLElement} element - The DOM element to toggle.
//  * @param {number} duration - The duration of the animation in milliseconds.
//  */
// function slideToggle(element, duration = 400) {
//     if (window.getComputedStyle(element).display === 'none') {
//         slideDown(element, duration);
//     } else {
//         slideUp(element, duration);
//     }
// }

// /**
//  * Slides an element up (hides it).
//  * @param {HTMLElement} element - The DOM element to slide up.
//  * @param {number} duration - The duration of the animation in milliseconds.
//  */
// function slideUp(element, duration = 400) {
//     element.style.transitionProperty = 'height, margin, padding';
//     element.style.transitionDuration = `${duration}ms`;
//     element.style.boxSizing = 'border-box';
//     element.style.height = `${element.offsetHeight}px`;
//     element.offsetHeight; // Trigger reflow
//     element.style.overflow = 'hidden';
//     element.style.height = '0';
//     element.style.paddingTop = '0';
//     element.style.paddingBottom = '0';
//     element.style.marginTop = '0';
//     element.style.marginBottom = '0';
//     window.setTimeout(() => {
//         element.style.display = 'none';
//         element.style.removeProperty('height');
//         element.style.removeProperty('padding-top');
//         element.style.removeProperty('padding-bottom');
//         element.style.removeProperty('margin-top');
//         element.style.removeProperty('margin-bottom');
//         element.style.removeProperty('overflow');
//         element.style.removeProperty('transition-duration');
//         element.style.removeProperty('transition-property');
//         // element.style.removeProperty('box-sizing'); // Keep box-sizing if it's a global default
//     }, duration);
// }

// /**
//  * Slides an element down (shows it).
//  * @param {HTMLElement} element - The DOM element to slide down.
//  * @param {number} duration - The duration of the animation in milliseconds.
//  */
// function slideDown(element, duration = 400) {
//     element.style.removeProperty('display');
//     let display = window.getComputedStyle(element).display;

//     if (display === 'none') {
//         display = 'block';
//     }

//     element.style.display = display;
//     let height = element.offsetHeight;
//     element.style.overflow = 'hidden';
//     element.style.height = '0';
//     element.style.paddingTop = '0';
//     element.style.paddingBottom = '0';
//     element.style.marginTop = '0';
//     element.style.marginBottom = '0';
//     element.offsetHeight; // Trigger reflow
//     element.style.boxSizing = 'border-box';
//     element.style.transitionProperty = 'height, margin, padding';
//     element.style.transitionDuration = `${duration}ms`;
//     element.style.height = `${height}px`;
//     element.style.removeProperty('padding-top');
//     element.style.removeProperty('padding-bottom');
//     element.style.removeProperty('margin-top');
//     element.style.removeProperty('margin-bottom');
//     window.setTimeout(() => {
//         element.style.removeProperty('height');
//         element.style.removeProperty('overflow');
//         element.style.removeProperty('transition-duration');
//         element.style.removeProperty('transition-property');
//         // element.style.removeProperty('box-sizing');
//     }, duration);
// }

// /**
//  * Checks if an element is hidden (equivalent to jQuery's :hidden selector).
//  * @param {HTMLElement} element - The DOM element to check.
//  * @returns {boolean} True if the element is hidden, false otherwise.
//  */
// function isHidden(element) {
//     return (element.offsetParent === null);
// }

// /**
//  * Gets all sibling elements of a given element, optionally filtered by a selector.
//  * @param {HTMLElement} element - The reference element.
//  * @param {string} [selector] - Optional CSS selector to filter siblings.
//  * @returns {HTMLElement[]} An array of sibling elements.
//  */
// function getSiblings(element, selector) {
//     const siblings = Array.from(element.parentNode.children).filter(child => child !== element);
//     if (selector) {
//         return siblings.filter(child => child.matches(selector));
//     }
//     return siblings;
// }

// /**
//  * Gets the next visible sibling element.
//  * @param {HTMLElement} element - The starting element.
//  * @returns {HTMLElement|null} The next visible sibling, or null if none found.
//  */
// function getNextVisibleSibling(element) {
//     let sibling = element.nextElementSibling;
//     while (sibling) {
//         if (!isHidden(sibling)) {
//             return sibling;
//         }
//         sibling = sibling.nextElementSibling;
//     }
//     return null;
// }

// // --- Main Script Logic ---

// document.addEventListener('DOMContentLoaded', function() {

  
//     // Function to change search input placeholder based on screen width
//     function changeSearchPlaceholder() {
//         const windowWidth = window.innerWidth;
//         const searchInput = document.querySelector("#shopify-section-static-header input.form-field-input");
//         if (searchInput) {
//             if (windowWidth < 1024) {
//                 searchInput.setAttribute("placeholder", "Search");
//             } else {
//                 searchInput.setAttribute("placeholder", "Search for a product");
//             }
//         }
//     }

//     // Function to change newsletter input placeholder
//     function changeNewsletterPlaceholder() {
//         const newsletterEmailInput = document.getElementById("newsletter_email");
//         if (newsletterEmailInput) {
//             // The original jQuery code had a comma instead of a semicolon,
//             // which made the condition 'w < "1024"' effectively ignored.
//             // Replicating the original observed behavior: always set this placeholder.
//             newsletterEmailInput.setAttribute("placeholder", "Your email address goes here");
//         }
//     }

//     // Append paragraph after a specific heading
//     const promoGridTitle = document.querySelector("#site-main > div.promo-grid--section:nth-child(4) > section.promo-grid--container > h2.home-section--title");
//     if (promoGridTitle) {
//         promoGridTitle.insertAdjacentHTML("afterend", "<p>Explore our curated selection of the most popular games, toys, and miscellaneous nerd stuff.</p>");
//     }

//     // Append collection links to mega-nav (Brands)
//     const meganav01Collections = document.getElementById("meganav_01_collections");
//     if (!meganav01Collections) {
//         const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(1) .navmenu-meganav--desktop");
//         if (targetElement) {
//             targetElement.insertAdjacentHTML("beforeend", "<ul id='meganav_01_collections'></ul>");
//             // Re-select the element after it's added to the DOM
//             const newMeganav01Collections = document.getElementById("meganav_01_collections");
//             if (newMeganav01Collections) {
               
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/magic-the-gathering'><img src='//poggers.com/cdn/shop/t/132/assets/Magic-the-gathering.svg?v=111871483142436146631728642814' alt='Magic The Gathering Collection' width='78' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dragon-ball-super-collectible-card-game-ccg'><img src='//poggers.com/cdn/shop/t/132/assets/Dragon-ball-super.svg?v=46442417606065436091728642805' alt='Dragon Ball Super Collection' width='300' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/yu-gi-oh-trading-card-game'><img src='//poggers.com/cdn/shop/t/132/assets/yu-gi-oh-trading-card-game.svg?v=54357980300839970811728642933' alt='Yugioh Cards Collection' width='300' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/pokemon'><img src='//poggers.com/cdn/shop/t/132/assets/Pokemon.svg?v=51584614182467986621728642825' alt='Pokemon Collection' width='300' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/funko'><img src='//poggers.com/cdn/shop/t/132/assets/funko.svg?v=74140181443896857161728642846' alt='Funko Collection' width='58' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dark-horse'><img src='//poggers.com/cdn/shop/t/132/assets/Dark-horse.svg?v=78792294509384747801728642802' alt='Dark Horse Collection' width='76' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/fantasy-flight-games'><img src='//poggers.com/cdn/shop/t/132/assets/Fantasy-flight-games.svg?v=27859079792983918891728642808' alt='Fantasy Flight Games Collection' width='117' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/wizards-of-the-coast'><img src='//poggers.com/cdn/shop/t/132/assets/Wizards-of-the-coast.svg?v=84893889049524788031728642835' alt='Wizards of the Coast Collection' width='47' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mattel'><img src='//poggers.com/cdn/shop/t/132/assets/Mattel.svg?v=87684629429966312271728642816' alt='Mattel Collection' width='150' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mcfarlane-toys'><img src='//poggers.com/cdn/shop/t/132/assets/Mcfarlane-toys.svg?v=104441502495165623471728642816' alt='McFarlane Toys Collection' width='109' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/eaglemoss'><img src='//poggers.com/cdn/shop/t/132/assets/Eaglemoss.svg?v=143664752419240807421728642806' alt='Eaglemoss Collection' width='112' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/hasbro'><img src='//poggers.com/cdn/shop/t/132/assets/Hasbro.svg?v=48002932304428569501728642809' alt='Hasbro Collection' width='278' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/ultra-pro-international'><img src='//poggers.com/cdn/shop/t/132/assets/Ultra%20Pro%20Entertainment.webp?v=163413835369023292451728642834' alt='Ultra Pro Entertainment Collection' width='150' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/abystyle'><img src='//poggers.com/cdn/shop/t/132/assets/ABYstyle.svg?v=84108083075720080001728642785' alt='ABYstyle Collection' width='75' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/weta-workshop'><img src='//poggers.com/cdn/shop/t/132/assets/Weta-workshop.svg?v=45327749992067362591728642834' alt='Weta Workshop Collection' width='62' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/banpresto'><img src='//poggers.com/cdn/shop/t/132/assets/banpresto.svg' alt='BANPRESTO Collection' width='150' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/kotobukiya'><img src='//poggers.com/cdn/shop/t/132/assets/Kotobukiya.svg?v=134134435200247417871728642812' alt='Kotobukiya Collection' width='75' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/great-eastern-entertainment'><img src='//poggers.com/cdn/shop/t/132/assets/great-eastern-entertainment.svg?v=67424990906297888121728642847' alt='Great Eastern Entertainment Collection' width='150' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/japanime-games'><img src='//poggers.com/cdn/shop/t/132/assets/Japanime-games.svg?v=166046910105281752781728642810' alt='Japanime Games Collection' width='41' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mega-bloks'><img src='//poggers.com/cdn/shop/t/132/assets/Mega-bloks.svg?v=123195507218788890271728642817' alt='Mega Bloks Collection' width='44' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/konami'><img src='//poggers.com/cdn/shop/t/132/assets/Konami.svg?v=182315273251784401371728642811' alt='Konami Collection' width='67' height='auto'/></a>");
//                 newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/little-buddy-usa'><img src='//poggers.com/cdn/shop/t/132/assets/Little-buddy-usa.svg?v=109233915571167425251728642813' alt='Little Buddy USA Collection' width='36' height='auto'/></a>");
//             }
//         }
//     }

//     // Append collection links to mega-nav (Games)
//     const meganav02Collections = document.getElementById("meganav_02_collections"); 
//     if (!meganav02Collections) {
//         const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(2) .navmenu-meganav--desktop");
//         if (targetElement) {
//             targetElement.insertAdjacentHTML("beforeend", "<div id='meganav_02_collections'></div>");
//             const newMeganav02Collections = document.getElementById("meganav_02_collections");
//             if (newMeganav02Collections) {
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/nintendo-games'><img src='//poggers.com/cdn/shop/t/132/assets/Nintendo-games.svg?v=12017194960884540551728642821' alt='Nintendo Games Collection' width='70' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/playstation-games'><img src='//poggers.com/cdn/shop/t/132/assets/Playstation-games.svg?v=98357649842160029101728642825' alt='PlayStation Games Collection' width='89' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/xbox-games'><img src='//poggers.com/cdn/shop/t/132/assets/Xbox-games.svg?v=66767892755236434571728642836' alt='Xbox Games Collection' width='64' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/ubisoft'><img src='//poggers.com/cdn/shop/t/132/assets/Ubisoft.svg?v=27107604004678682151728642833' alt='Ubisoft Collection' width='72' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/2k-games'><img src='//poggers.com/cdn/shop/t/132/assets/2k-games.svg?v=68455794142055324681728642784' alt='2k Games Collection' width='29' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/activision'><img src='//poggers.com/cdn/shop/t/132/assets/Activision.svg?v=35539897750529697741728642785' alt='Activision Collection' width='74' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/capcom'><img src='//poggers.com/cdn/shop/t/132/assets/Capcom.svg?v=136502547640230581011728642800' alt='CAPCOM Collection' width='82' height='auto'/></a>");
//                 newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/sega'><img src='//poggers.com/cdn/shop/t/132/assets/Sega.svg?v=147012398277622419921728642828' alt='Sega Collection' width='56' height='auto'/></a>");
//             }
//         }
//     }

//     // Append text to mega-nav links (Media)
//     const navmenuLi3 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(3) .navmenu-meganav--desktop ul.navmenu-depth-2");
//     if (navmenuLi3) {
//         navmenuLi3.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<br><span>Japanese anime movies &amp; shows on Blu-ray</span>");
//         navmenuLi3.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<br><span>Popular comic books from from Marvel and more</span>");
//         navmenuLi3.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<br><span>Soundtracks from popular movies</span>");
//         navmenuLi3.querySelector("li:nth-child(4) > a")?.insertAdjacentHTML("beforeend", "<br><span>Soundtracks for japanese anime series and movies</span>");
//         navmenuLi3.querySelector("li:nth-child(5) > a")?.insertAdjacentHTML("beforeend", "<br><span>Video game soundtracks &amp; music</span>");
//         navmenuLi3.querySelector("li:nth-child(6) > a")?.insertAdjacentHTML("beforeend", "<br><span>Popular manga books and comics</span>");
//         navmenuLi3.querySelector("li:nth-child(8)")?.insertAdjacentHTML("afterbegin", "<div><span>//////</span></div>");
//     }

//     // Append text and image to mega-nav links (Clothing & Gear)
//     const navmenuLi4 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(4) .navmenu-meganav--desktop ul.navmenu-depth-2");
//     if (navmenuLi4) {
//         navmenuLi4.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<span>Gaming and anime apparel for fashionable nerds</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi4.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<span>Stylish and trendy gaming and anime themed bags</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi4.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<span>Functional gaming and anime themed accessories</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi4.querySelector("li:nth-child(4)")?.insertAdjacentHTML("afterbegin", "<div><span>Shop All Clothing &amp; Gear</span><br><span>Clothing, Bags, Gear &amp; More</span></div>");
//     }

//     // Append text to mega-nav links (Electronics)
//     const navmenuLi5 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(5) .navmenu-meganav--desktop ul.navmenu-depth-2");
//     if (navmenuLi5) {
//         navmenuLi5.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<br><span>Playstation, Xbox, and Nintendo consoles</span>");
//         navmenuLi5.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<br><span>Controllers for Playstation, Nintendo, and Xbox</span>");
//         navmenuLi5.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<br><span>Multipurpose headphones and gaming headsets.</span>");
//         navmenuLi5.querySelector("li:nth-child(4) > a")?.insertAdjacentHTML("beforeend", "<br><span>Gadgets and accessories for your gaming PC</span>");
//         navmenuLi5.querySelector("li:nth-child(5)")?.insertAdjacentHTML("afterbegin", "<div><span>Shop All Electronics</span><br><span>Headphones, Controllers, Consoles & Accessories</span></div>");
//     }

//     // Append text and image to mega-nav links (Gifts & Accessories)
//     const navmenuLi6 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(6) .navmenu-meganav--desktop ul.navmenu-depth-2");
//     if (navmenuLi6) {
//         navmenuLi6.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<span>Gaming and anime themed keychains</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi6.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<span>Nerdy mugs for all types of beverages</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi6.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<span>Random products that make great gifts</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi6.querySelector("li:nth-child(4) > a")?.insertAdjacentHTML("beforeend", "<span>Miscellaneous Gifts and Accessories</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
//         navmenuLi6.querySelector("li:nth-child(5)")?.insertAdjacentHTML("afterbegin", "<div><span>Shop All Gifts &amp; Accessories</span><br><span>Gifts, Keychains, Mugs, and Miscellaneous Accessories</span></div>");
//     }

//     // Append collection links to mega-nav (Fandoms)
//     const meganav08Collections = document.getElementById("meganav_08_collections");
//     if (!meganav08Collections) {
//         const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(8) .navmenu-meganav--desktop");
//         if (targetElement) {
//             targetElement.insertAdjacentHTML("beforeend", "<div id='meganav_08_collections'></div>");
//             const newMeganav08Collections = document.getElementById("meganav_08_collections");
//             if (newMeganav08Collections) {
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/magic-the-gathering'><img src='//poggers.com/cdn/shop/t/132/assets/Magic-the-gathering.svg?v=111871483142436146631728642814' alt='Magic The Gathering Collection' width='78' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dragon-ball-super'><img src='//poggers.com/cdn/shop/t/132/assets/Dragon-ball-super.svg?v=46442417606065436091728642805' alt='Dragon Ball Super Collection' width='300' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/disney'><img src='//poggers.com/cdn/shop/t/132/assets/Disney.svg?v=121939666926030412871728642845' alt='disney' width='150' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/pokemon'><img src='//poggers.com/cdn/shop/t/132/assets/Pokemon.svg?v=51584614182467986621728642825' alt='Pokemon Collection' width='300' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/marvel'><img src='//poggers.com/cdn/shop/t/132/assets//Marvel.svg?94759' alt='marvel' width='150' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/star-wars'><img src='//poggers.com/cdn/shop/t/132/assets//Star_Wars.svg?94759' alt='star-wars' width='150' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/yu-gi-oh-tcg-trading-card-game/'><img src='//poggers.com/cdn/shop/t/132//assets/yu-gi-oh-trading-card-game.svg?v=54357980300839970811728642933' alt='Yugioh Cards Collection' width='300' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/naruto/'><img src='//poggers.com/cdn/shop/t/132/assets/Naruto.svg?v=56707481609889685101728642820' alt='Naruto Collection' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/demon-slayer'><img src='//poggers.com/cdn/shop/t/132/assets/Demon_Slayer.svg?v=77706483445653047011728642803' alt='Demon_Slayer Collection' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/harry-potter'><img src='//poggers.com/cdn/shop/t/132/assets//Harry_Potter.svg?94759' alt='harry-potter' width='300' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/one-piece'><img src='//poggers.com/cdn/shop/t/132/assets//One_Piece.svg?94759' alt='One-piece' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/my-hero-academia'><img src='//poggers.com/cdn/shop/t/132/assets//My_Hero_Academia.svg?94759' alt='My_Hero_Academia' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/super-mario'><img class='ht_setmr' src='//poggers.com/cdn/shop/t/132//assets/Super_Mario.svg?v=9865584971961433461728642831' alt='Super_Mario Collection' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/the-lord-of-the-rings'><img src='//poggers.com/cdn/shop/t/132//assets//The_Lord_of_The_Ring.svg?94759' alt='the-lord-of-the-rings' width='300' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dc-comics'><img src='//poggers.com/cdn/shop/t/132/assets//DC_Comics.svg?94759' alt='DC_Comics' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/naruto-shippuden'><img src='//poggers.com/cdn/shop/t/132//assets//Naruto_Shippuden.svg?94759' alt='Naruto_Shippuden' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/batman'><img src='//poggers.com/cdn/shop/t/132/assets//Batman.svg?94759' alt='Batman' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/monopoly'><img src='//poggers.com/cdn/shop/t/132/assets//white-Monopoly.svg?94759' alt='monopoly' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/avengers'><img src='//poggers.com/cdn/shop/t/132/assets//Avengers.svg?94759' alt='avengers' width='200' height='auto'/></a>");
//                 newMeganav08Collections.insertAdjacentHTML("beforeend", "<div class='bxshp_1'><div class='shopbtn'><a href='/collections/fandoms'>Shop All fandoms</a></div></div>");
//             }
//         }
//     }

//     // Append collection links to mega-nav (Manufacturers)
//     const meganav09Collections = document.getElementById("meganav_09_collections");
//     if (!meganav09Collections) {
//         const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(9) .navmenu-meganav--desktop");
//         if (targetElement) {
//             targetElement.insertAdjacentHTML("beforeend", "<div id='meganav_09_collections'></div>");
//             const newMeganav09Collections = document.getElementById("meganav_09_collections");
//             if (newMeganav09Collections) {
               
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/bioworld'><img src='//poggers.com/cdn/shop/t/132/assets/Bioworld.svg?v=62506454778468797751728642798' alt='Bioworld Collection' width='200' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/wizards-of-the-coast'><img src='//poggers.com/cdn/shop/t/132/assets/Wizards-of-the-coast.svg?v=364044971755591351728642931' alt='Wizards of the Coast Collection' width='47' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mcfarlane-toys'><img src='//poggers.com/cdn/shop/t/132/assets/Mcfarlane-toys.svg?v=104441502495165623471728642816' alt='McFarlane Toys Collection' width='109' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/banpresto'><img src='//poggers.com/cdn/shop/t/132/assets/banpresto.svg?v=40958933942489297601728642839' alt='BANPRESTO Collection' width='150' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/abystyle'><img src='//poggers.com/cdn/shop/t/132/assets/ABYstyle.svg?v=84108083075720080001728642785' alt='ABYstyle Collection' width='75' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/kotobukiya'><img src='//poggers.com/cdn/shop/t/132/assets/Kotobukiya.svg?v=134134435200247417871728642812' alt='Kotobukiya Collection' width='75' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/eaglemoss'><img src='//poggers.com/cdn/shop/t/132/assets/Eaglemoss.svg?v=143664752419240807421728642806' alt='Eaglemoss Collection' width='112' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/great-eastern-entertainment'><img src='//poggers.com/cdn/shop/t/132/assets/great-eastern-entertainment.svg?v=67424990906297888121728642847' alt='Great Eastern Entertainment Collection' width='150' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/the-pokemon-company-international'><img src='//poggers.com/cdn/shop/t/132/assets/the-pokemon-company-international.svg?v=39999715015748100831728642928' alt='The pokemon company international' width='200' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/weta-workshop'><img src='//poggers.com/cdn/shop/t/132/assets/Weta-workshop.svg?v=45327749992067362591728642834' alt='Weta Workshop Collection' width='62' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/konami'><img src='//poggers.com/cdn/shop/t/132/assets/Konami.svg?v=182315273251784401371728642811' alt='Konami Collection' width='67' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mega-bloks'><img src='//poggers.com/cdn/shop/t/132/assets/Mega-bloks.svg?v=123195507218788890271728642817' alt='Mega Bloks Collection' width='44' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/japanime-games'><img src='//poggers.com/cdn/shop/t/132/assets/Japanime-games.svg?v=166046910105281752781728642810' alt='Japanime Games Collection' width='41' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/jinx'><img src='//poggers.com/cdn/shop/t/132/assets/jinx.svg?v=59983067871140467281728642848' alt='Jinx Collection' width='200' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/little-buddy-usa'><img src='//poggers.com/cdn/shop/t/132/assets/Little-buddy-usa.svg?v=109233915571167425251728642813' alt='Little Buddy USA Collection' width='36' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/bethesda-softworks'><img src='//poggers.com/cdn/shop/t/132/assets/bethesda-softworks.svg?v=120575537759908381011728642840' alt='bethesda softworks' width='200' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/sega'><img src='//poggers.com/cdn/shop/t/132/assets/Sega.svg?v=147012398277622419921728642828' alt='Sega Collection' width='56' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/ubisoft'><img src='//poggers.com/cdn/shop/t/132/assets/Ubisoft.svg?v=27107604004678682151728642833' alt='Ubisoft Collection' width='72' height='auto'/></a>");
//                 newMeganav09Collections.insertAdjacentHTML("beforeend", "<div class='bxshp_1'><div class='shopbtn'><a href='/collections/manufacturers'>Shop All Manufacturers</a></div></div>");
//             }
//         }
//     }

//     // Event listener for social sharing buttons (wishlist_share_bookmark_button)
//     const wishlistShareButton1 = document.querySelector("#wishlist_share_bookmark_button > svg:nth-child(1)");
//     if (wishlistShareButton1) {
//         wishlistShareButton1.addEventListener("click", function() {
//             const socialSharingButtons = document.getElementById("social-sharing-buttons");
//             if (socialSharingButtons) {
//                 slideToggle(socialSharingButtons);
//             }
//         });
//     }

//     const wishlistShareButton2 = document.querySelector("#wishlist_share_bookmark_button > svg:nth-child(2)");
//     if (wishlistShareButton2) {
//         wishlistShareButton2.addEventListener("click", function() {
//             const socialSharingButtonsMob = document.getElementById("social-sharing-buttons-mob");
//             if (socialSharingButtonsMob) {
//                 slideToggle(socialSharingButtonsMob);
//             }
//         });
//     }

//     // Product quantity controls
//     const quantitySelect = document.getElementById("product-quantity-select");
//     const decreaseButton = document.getElementById("decrease_product_quantity");
//     const increaseButton = document.getElementById("increase_product_quantity");

//     if (decreaseButton && quantitySelect) {
//         decreaseButton.addEventListener("click", function() {
//             let currentQuantity = parseInt(quantitySelect.value);
//             if (currentQuantity > 1) {
//                 quantitySelect.value = currentQuantity - 1;
//                 quantitySelect.dispatchEvent(new Event('change')); // Trigger change event
//             }
//         });
//     }

//     if (increaseButton && quantitySelect) {
//         increaseButton.addEventListener("click", function() {
//             let currentQuantity = parseInt(quantitySelect.value);
//             const maxOption = quantitySelect.querySelector("option:last-child");
//             if (maxOption) {
//                 const maxQuantity = parseInt(maxOption.value);
//                 if (currentQuantity < maxQuantity) {
//                     quantitySelect.value = currentQuantity + 1;
//                     quantitySelect.dispatchEvent(new Event('change')); // Trigger change event
//                 }
//             }
//         });
//     }

//     // Product gallery navigation (scroller buttons)
//     const galleryScrollerButtons = document.querySelectorAll("#site-main > div.product--section > section.product--container > article.product--outer > div.product-gallery div.gallery-navigation--scroller + div > div > button");
//     galleryScrollerButtons.forEach(button => {
//         button.addEventListener("click", function() {
//             const index = Array.from(this.parentNode.children).indexOf(this); // Get index of clicked button
//             this.setAttribute("data-selected", "true");
//             getSiblings(this).forEach(sibling => sibling.setAttribute("data-selected", "false"));

//             const targetThumbnail = this.closest("div.product-gallery--navigation")?.querySelectorAll("button.product-gallery--media-thumbnail")[index];
//             if (targetThumbnail) {
//                 targetThumbnail.click(); // Simulate click on corresponding media thumbnail
//             }
//         });
//     });

//     // Product gallery media thumbnails
//     const mediaThumbnails = document.querySelectorAll("#site-main > div.product--section > section.product--container > article.product--outer > div.product-gallery button.product-gallery--media-thumbnail");
//     mediaThumbnails.forEach(thumbnail => {
//         thumbnail.addEventListener("click", function() {
//             const index = Array.from(this.parentNode.children).indexOf(this); // Get index of clicked thumbnail
//             const targetButton = this.closest("div.product-gallery--navigation")?.querySelectorAll("button.product-gallery-thumbnail-button")[index];
//             if (targetButton) {
//                 targetButton.setAttribute("data-selected", "true");
//                 getSiblings(targetButton).forEach(sibling => sibling.setAttribute("data-selected", "false"));
//             }
//         });
//     });

//     // Hide collection filters with only one item
//     document.querySelectorAll("ul.collection-filters__filter").forEach(filterUl => {
//         if (filterUl.children.length === 1) {
//             const parentFilterGroup = filterUl.closest("div.filter-form");
//             if (parentFilterGroup) {
//                 parentFilterGroup.style.display = 'none';
//             }
//         }
//     });

//     // Auto-click first visible filter group heading if first is hidden
//     const firstFilterGroup = document.querySelector("div.collection-filters__filter-group:first-child");
//     if (firstFilterGroup && isHidden(firstFilterGroup)) {
//         const nextVisibleGroupHeading = getNextVisibleSibling(firstFilterGroup)?.querySelector("button.collection-filters__filter-group-heading");
//         if (nextVisibleGroupHeading) {
//             nextVisibleGroupHeading.click();
//         }
//     }

//     // Returns page text modifications
//     const returnsContainer = document.querySelector("#site-main > div.Esc-returns-container");
//     if (returnsContainer) {
//         const firstP = returnsContainer.querySelector("div:first-of-type > p:first-child");
//         if (firstP) {
//             firstP.textContent = "Need to return something? No problem. Just enter your email address or phone number and the order number.";
//         }

//         const emailLabel = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > label[for='email']");
//         if (emailLabel) {
//             emailLabel.textContent = "Email Address or Phone Number";
//         }

//         const emailInput = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > #email");
//         if (emailInput) {
//             emailInput.setAttribute("placeholder", "Your Email Address");
//         }

//         const orderNumberLabel = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > div.form-group > label[for='order_number']");
//         if (orderNumberLabel) {
//             orderNumberLabel.textContent = "Order Number";
//         }

//         const orderNumberInput = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > div.form-group > #order_number");
//         if (orderNumberInput) {
//             orderNumberInput.setAttribute("placeholder", "Your Order Number");
//         }

//         returnsContainer.insertAdjacentHTML("afterbegin", "<figure id='returns-unicorn-wrapper'><img src='https://cdn.shopify.com/s/files/1/0400/9767/7479/files/returns-unicorn_456e9541-ef68-4918-bdcd-526293e76b42.svg?v=1662877434' alt='Poggers Returns Unicorn'></figure><h1 id='returns-page-title'>Returns</h1>");
//     }

//     // Contact message character counter
//     const contactMessageInput = document.getElementById("contact_message");
//     if (contactMessageInput) {
//         const charCounter = document.getElementById("my_char_counter"); // Assuming this element exists
//         if (charCounter) {
//             contactMessageInput.addEventListener("keyup", function() {
//                 charCounter.textContent = this.value.length;
//             });
//         }
//     }

//     // Password visibility toggle
//     document.querySelectorAll("img[src*='_password.svg']").forEach(img => {
//         img.addEventListener("click", function() {
//             const passwordInput = this.previousElementSibling;
//             if (passwordInput && passwordInput.tagName === 'INPUT') { // Ensure it's an input
//                 const hideSrc = "//poggers.com/cdn/shop/t/132/assets/hide_password.svg?v=162480643263517671001728642848";
//                 const viewSrc = "//poggers.com/cdn/shop/t/132/assets/view_password.svg?v=116165601475903126981728642930";

//                 if (this.getAttribute("src").includes(viewSrc)) {
//                     this.setAttribute("src", hideSrc);
//                     passwordInput.setAttribute("type", "text");
//                 } else {
//                     this.setAttribute("src", viewSrc);
//                     passwordInput.setAttribute("type", "password");
//                 }
//             }
//         });
//     });

//     // Window resize event listener for placeholders
//     window.addEventListener("resize", function() {
//         changeSearchPlaceholder();
//         changeNewsletterPlaceholder();
//     });

//     // Initial calls for placeholders on page load
//     changeSearchPlaceholder();
//     changeNewsletterPlaceholder();
// });

// // Loading screen hide on window load
// // window.addEventListener("load", function() {




// --- Helper Functions (Vanilla JS equivalents of jQuery methods) ---

/**
 * Toggles the display of an element with a slide-up/slide-down animation.
 * @param {HTMLElement} element - The DOM element to toggle.
 * @param {number} duration - The duration of the animation in milliseconds.
 */
function slideToggle(element, duration = 400) {
    if (window.getComputedStyle(element).display === 'none') {
        slideDown(element, duration);
    } else {
        slideUp(element, duration);
    }
}

/**
 * Slides an element up (hides it).
 * @param {HTMLElement} element - The DOM element to slide up.
 * @param {number} duration - The duration of the animation in milliseconds.
 */
function slideUp(element, duration = 400) {
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = `${duration}ms`;
    element.style.boxSizing = 'border-box';
    element.style.height = `${element.offsetHeight}px`;
    element.offsetHeight; // Trigger reflow
    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginTop = '0';
    element.style.marginBottom = '0';
    window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
        // element.style.removeProperty('box-sizing'); // Keep box-sizing if it's a global default
    }, duration);
}

/**
 * Slides an element down (shows it).
 * @param {HTMLElement} element - The DOM element to slide down.
 * @param {number} duration - The duration of the animation in milliseconds.
 */
function slideDown(element, duration = 400) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;

    if (display === 'none') {
        display = 'block';
    }

    element.style.display = display;
    let height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginTop = '0';
    element.style.marginBottom = '0';
    element.offsetHeight; // Trigger reflow
    element.style.boxSizing = 'border-box';
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = `${duration}ms`;
    element.style.height = `${height}px`;
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
        // element.style.removeProperty('box-sizing');
    }, duration);
}

/**
 * Checks if an element is hidden (equivalent to jQuery's :hidden selector).
 * @param {HTMLElement} element - The DOM element to check.
 * @returns {boolean} True if the element is hidden, false otherwise.
 */
function isHidden(element) {
    return (element.offsetParent === null);
}

/**
 * Gets all sibling elements of a given element, optionally filtered by a selector.
 * @param {HTMLElement} element - The reference element.
 * @param {string} [selector] - Optional CSS selector to filter siblings.
 * @returns {HTMLElement[]} An array of sibling elements.
 */
function getSiblings(element, selector) {
    const siblings = Array.from(element.parentNode.children).filter(child => child !== element);
    if (selector) {
        return siblings.filter(child => child.matches(selector));
    }
    return siblings;
}

/**
 * Gets the next visible sibling element.
 * @param {HTMLElement} element - The starting element.
 * @returns {HTMLElement|null} The next visible sibling, or null if none found.
 */
function getNextVisibleSibling(element) {
    let sibling = element.nextElementSibling;
    while (sibling) {
        if (!isHidden(sibling)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
    return null;
}

// --- Main Script Logic ---

document.addEventListener('DOMContentLoaded', function() {

  
    // Function to change search input placeholder based on screen width
    function changeSearchPlaceholder() {
        const windowWidth = window.innerWidth;
        const searchInput = document.querySelector("#shopify-section-static-header input.form-field-input");
        if (searchInput) {
            if (windowWidth < 1024) {
                searchInput.setAttribute("placeholder", "Search");
            } else {
                searchInput.setAttribute("placeholder", "Search for a product");
            }
        }
    }

    // Function to change newsletter input placeholder
    function changeNewsletterPlaceholder() {
        const newsletterEmailInput = document.getElementById("newsletter_email");
        if (newsletterEmailInput) {
            // The original jQuery code had a comma instead of a semicolon,
            // which made the condition 'w < "1024"' effectively ignored.
            // Replicating the original observed behavior: always set this placeholder.
            newsletterEmailInput.setAttribute("placeholder", "Your email address goes here");
        }
    }

    // Append paragraph after a specific heading
    const promoGridTitle = document.querySelector("#site-main > div.promo-grid--section:nth-child(4) > section.promo-grid--container > h2.home-section--title");
    if (promoGridTitle) {
        promoGridTitle.insertAdjacentHTML("afterend", "<p>Explore our curated selection of the most popular games, toys, and miscellaneous nerd stuff.</p>");
    }

    // Append collection links to mega-nav (Brands)
    const meganav01Collections = document.getElementById("meganav_01_collections");
    if (!meganav01Collections) {
        const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(1) .navmenu-meganav--desktop");
        if (targetElement) {
            targetElement.insertAdjacentHTML("beforeend", "<ul id='meganav_01_collections'></ul>");
            // Re-select the element after it's added to the DOM
            const newMeganav01Collections = document.getElementById("meganav_01_collections");
            if (newMeganav01Collections) {
               
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/magic-the-gathering'><img src='//poggers.com/cdn/shop/t/132/assets/Magic-the-gathering.svg?v=111871483142436146631728642814' alt='Magic The Gathering Collection' width='78' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dragon-ball-super-collectible-card-game-ccg'><img src='//poggers.com/cdn/shop/t/132/assets/Dragon-ball-super.svg?v=46442417606065436091728642805' alt='Dragon Ball Super Collection' width='300' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/yu-gi-oh-trading-card-game'><img src='//poggers.com/cdn/shop/t/132/assets/yu-gi-oh-trading-card-game.svg?v=54357980300839970811728642933' alt='Yugioh Cards Collection' width='300' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/pokemon'><img src='//poggers.com/cdn/shop/t/132/assets/Pokemon.svg?v=51584614182467986621728642825' alt='Pokemon Collection' width='300' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/funko'><img src='//poggers.com/cdn/shop/t/132/assets/funko.svg?v=74140181443896857161728642846' alt='Funko Collection' width='58' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dark-horse'><img src='//poggers.com/cdn/shop/t/132/assets/Dark-horse.svg?v=78792294509384747801728642802' alt='Dark Horse Collection' width='76' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/fantasy-flight-games'><img src='//poggers.com/cdn/shop/t/132/assets/Fantasy-flight-games.svg?v=27859079792983918891728642808' alt='Fantasy Flight Games Collection' width='117' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/wizards-of-the-coast'><img src='//poggers.com/cdn/shop/t/132/assets/Wizards-of-the-coast.svg?v=84893889049524788031728642835' alt='Wizards of the Coast Collection' width='47' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mattel'><img src='//poggers.com/cdn/shop/t/132/assets/Mattel.svg?v=87684629429966312271728642816' alt='Mattel Collection' width='150' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mcfarlane-toys'><img src='//poggers.com/cdn/shop/t/132/assets/Mcfarlane-toys.svg?v=104441502495165623471728642816' alt='McFarlane Toys Collection' width='109' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/eaglemoss'><img src='//poggers.com/cdn/shop/t/132/assets/Eaglemoss.svg?v=143664752419240807421728642806' alt='Eaglemoss Collection' width='112' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/hasbro'><img src='//poggers.com/cdn/shop/t/132/assets/Hasbro.svg?v=48002932304428569501728642809' alt='Hasbro Collection' width='278' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/ultra-pro-international'><img src='//poggers.com/cdn/shop/t/132/assets/Ultra%20Pro%20Entertainment.webp?v=163413835369023292451728642834' alt='Ultra Pro Entertainment Collection' width='150' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/abystyle'><img src='//poggers.com/cdn/shop/t/132/assets/ABYstyle.svg?v=84108083075720080001728642785' alt='ABYstyle Collection' width='75' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/weta-workshop'><img src='//poggers.com/cdn/shop/t/132/assets/Weta-workshop.svg?v=45327749992067362591728642834' alt='Weta Workshop Collection' width='62' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/banpresto'><img src='//poggers.com/cdn/shop/t/132/assets/banpresto.svg' alt='BANPRESTO Collection' width='150' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/kotobukiya'><img src='//poggers.com/cdn/shop/t/132/assets/Kotobukiya.svg?v=134134435200247417871728642812' alt='Kotobukiya Collection' width='75' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/great-eastern-entertainment'><img src='//poggers.com/cdn/shop/t/132/assets/great-eastern-entertainment.svg?v=67424990906297888121728642847' alt='Great Eastern Entertainment Collection' width='150' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/japanime-games'><img src='//poggers.com/cdn/shop/t/132/assets/Japanime-games.svg?v=166046910105281752781728642810' alt='Japanime Games Collection' width='41' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mega-bloks'><img src='//poggers.com/cdn/shop/t/132/assets/Mega-bloks.svg?v=123195507218788890271728642817' alt='Mega Bloks Collection' width='44' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/konami'><img src='//poggers.com/cdn/shop/t/132/assets/Konami.svg?v=182315273251784401371728642811' alt='Konami Collection' width='67' height='auto'/></a>");
                newMeganav01Collections.insertAdjacentHTML("beforeend", "<a href='/collections/little-buddy-usa'><img src='//poggers.com/cdn/shop/t/132/assets/Little-buddy-usa.svg?v=109233915571167425251728642813' alt='Little Buddy USA Collection' width='36' height='auto'/></a>");
            }
        }
    }

    // Append collection links to mega-nav (Games)
    const meganav02Collections = document.getElementById("meganav_02_collections"); 
    if (!meganav02Collections) {
        const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(2) .navmenu-meganav--desktop");
        if (targetElement) {
            targetElement.insertAdjacentHTML("beforeend", "<div id='meganav_02_collections'></div>");
            const newMeganav02Collections = document.getElementById("meganav_02_collections");
            if (newMeganav02Collections) {
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/nintendo-games'><img src='//poggers.com/cdn/shop/t/132/assets/Nintendo-games.svg?v=12017194960884540551728642821' alt='Nintendo Games Collection' width='70' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/playstation-games'><img src='//poggers.com/cdn/shop/t/132/assets/Playstation-games.svg?v=98357649842160029101728642825' alt='PlayStation Games Collection' width='89' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/xbox-games'><img src='//poggers.com/cdn/shop/t/132/assets/Xbox-games.svg?v=66767892755236434571728642836' alt='Xbox Games Collection' width='64' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/ubisoft'><img src='//poggers.com/cdn/shop/t/132/assets/Ubisoft.svg?v=27107604004678682151728642833' alt='Ubisoft Collection' width='72' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/2k-games'><img src='//poggers.com/cdn/shop/t/132/assets/2k-games.svg?v=68455794142055324681728642784' alt='2k Games Collection' width='29' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/activision'><img src='//poggers.com/cdn/shop/t/132/assets/Activision.svg?v=35539897750529697741728642785' alt='Activision Collection' width='74' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/capcom'><img src='//poggers.com/cdn/shop/t/132/assets/Capcom.svg?v=136502547640230581011728642800' alt='CAPCOM Collection' width='82' height='auto'/></a>");
                newMeganav02Collections.insertAdjacentHTML("beforeend", "<a href='/collections/sega'><img src='//poggers.com/cdn/shop/t/132/assets/Sega.svg?v=147012398277622419921728642828' alt='Sega Collection' width='56' height='auto'/></a>");
            }
        }
    }

    // Append text to mega-nav links (Media)
    const navmenuLi3 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(3) .navmenu-meganav--desktop ul.navmenu-depth-2");
    if (navmenuLi3) {
        navmenuLi3.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<br><span>Japanese anime movies &amp; shows on Blu-ray</span>");
        navmenuLi3.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<br><span>Popular comic books from from Marvel and more</span>");
        navmenuLi3.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<br><span>Soundtracks from popular movies</span>");
        navmenuLi3.querySelector("li:nth-child(4) > a")?.insertAdjacentHTML("beforeend", "<br><span>Soundtracks for japanese anime series and movies</span>");
        navmenuLi3.querySelector("li:nth-child(5) > a")?.insertAdjacentHTML("beforeend", "<br><span>Video game soundtracks &amp; music</span>");
        navmenuLi3.querySelector("li:nth-child(6) > a")?.insertAdjacentHTML("beforeend", "<br><span>Popular manga books and comics</span>");
        navmenuLi3.querySelector("li:nth-child(8)")?.insertAdjacentHTML("afterbegin", "<div><span>//////</span></div>");
    }

    // Append text and image to mega-nav links (Clothing & Gear)
    const navmenuLi4 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(4) .navmenu-meganav--desktop ul.navmenu-depth-2");
    if (navmenuLi4) {
        navmenuLi4.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<span>Gaming and anime apparel for fashionable nerds</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi4.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<span>Stylish and trendy gaming and anime themed bags</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi4.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<span>Functional gaming and anime themed accessories</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi4.querySelector("li:nth-child(4)")?.insertAdjacentHTML("afterbegin", "<div><span>Shop All Clothing &amp; Gear</span><br><span>Clothing, Bags, Gear &amp; More</span></div>");
    }

    // Append text to mega-nav links (Electronics)
    const navmenuLi5 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(5) .navmenu-meganav--desktop ul.navmenu-depth-2");
    if (navmenuLi5) {
        navmenuLi5.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<br><span>Playstation, Xbox, and Nintendo consoles</span>");
        navmenuLi5.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<br><span>Controllers for Playstation, Nintendo, and Xbox</span>");
        navmenuLi5.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<br><span>Multipurpose headphones and gaming headsets.</span>");
        navmenuLi5.querySelector("li:nth-child(4) > a")?.insertAdjacentHTML("beforeend", "<br><span>Gadgets and accessories for your gaming PC</span>");
        navmenuLi5.querySelector("li:nth-child(5)")?.insertAdjacentHTML("afterbegin", "<div><span>Shop All Electronics</span><br><span>Headphones, Controllers, Consoles & Accessories</span></div>");
    }

    // Append text and image to mega-nav links (Gifts & Accessories)
    const navmenuLi6 = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(6) .navmenu-meganav--desktop ul.navmenu-depth-2");
    if (navmenuLi6) {
        navmenuLi6.querySelector("li:nth-child(1) > a")?.insertAdjacentHTML("beforeend", "<span>Gaming and anime themed keychains</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi6.querySelector("li:nth-child(2) > a")?.insertAdjacentHTML("beforeend", "<span>Nerdy mugs for all types of beverages</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi6.querySelector("li:nth-child(3) > a")?.insertAdjacentHTML("beforeend", "<span>Random products that make great gifts</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi6.querySelector("li:nth-child(4) > a")?.insertAdjacentHTML("beforeend", "<span>Miscellaneous Gifts and Accessories</span><img src='//poggers.com/cdn/shop/t/132/assets/arrow_01.svg?v=122431337074365428031728642837' alt='right pointing arrow'>");
        navmenuLi6.querySelector("li:nth-child(5)")?.insertAdjacentHTML("afterbegin", "<div><span>Shop All Gifts &amp; Accessories</span><br><span>Gifts, Keychains, Mugs, and Miscellaneous Accessories</span></div>");
    }

    // Append collection links to mega-nav (Fandoms)
    const meganav08Collections = document.getElementById("meganav_08_collections");
    if (!meganav08Collections) {
        const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(8) .navmenu-meganav--desktop");
        if (targetElement) {
            targetElement.insertAdjacentHTML("beforeend", "<div id='meganav_08_collections'></div>");
            const newMeganav08Collections = document.getElementById("meganav_08_collections");
            if (newMeganav08Collections) {
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/magic-the-gathering'><img src='//poggers.com/cdn/shop/t/132/assets/Magic-the-gathering.svg?v=111871483142436146631728642814' alt='Magic The Gathering Collection' width='78' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dragon-ball-super'><img src='//poggers.com/cdn/shop/t/132/assets/Dragon-ball-super.svg?v=46442417606065436091728642805' alt='Dragon Ball Super Collection' width='300' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/disney'><img src='//poggers.com/cdn/shop/t/132/assets/Disney.svg?v=121939666926030412871728642845' alt='disney' width='150' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/pokemon'><img src='//poggers.com/cdn/shop/t/132/assets/Pokemon.svg?v=51584614182467986621728642825' alt='Pokemon Collection' width='300' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/marvel'><img src='//poggers.com/cdn/shop/t/132/assets//Marvel.svg?94759' alt='marvel' width='150' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/star-wars'><img src='//poggers.com/cdn/shop/t/132/assets//Star_Wars.svg?94759' alt='star-wars' width='150' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/yu-gi-oh-tcg-trading-card-game/'><img src='//poggers.com/cdn/shop/t/132//assets/yu-gi-oh-trading-card-game.svg?v=54357980300839970811728642933' alt='Yugioh Cards Collection' width='300' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/naruto/'><img src='//poggers.com/cdn/shop/t/132/assets/Naruto.svg?v=56707481609889685101728642820' alt='Naruto Collection' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/demon-slayer'><img src='//poggers.com/cdn/shop/t/132/assets/Demon_Slayer.svg?v=77706483445653047011728642803' alt='Demon_Slayer Collection' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/harry-potter'><img src='//poggers.com/cdn/shop/t/132/assets//Harry_Potter.svg?94759' alt='harry-potter' width='300' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/one-piece'><img src='//poggers.com/cdn/shop/t/132/assets//One_Piece.svg?94759' alt='One-piece' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/my-hero-academia'><img src='//poggers.com/cdn/shop/t/132/assets//My_Hero_Academia.svg?94759' alt='My_Hero_Academia' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/super-mario'><img class='ht_setmr' src='//poggers.com/cdn/shop/t/132//assets/Super_Mario.svg?v=9865584971961433461728642831' alt='Super_Mario Collection' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/the-lord-of-the-rings'><img src='//poggers.com/cdn/shop/t/132//assets//The_Lord_of_The_Ring.svg?94759' alt='the-lord-of-the-rings' width='300' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/dc-comics'><img src='//poggers.com/cdn/shop/t/132/assets//DC_Comics.svg?94759' alt='DC_Comics' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/naruto-shippuden'><img src='//poggers.com/cdn/shop/t/132//assets//Naruto_Shippuden.svg?94759' alt='Naruto_Shippuden' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/batman'><img src='//poggers.com/cdn/shop/t/132/assets//Batman.svg?94759' alt='Batman' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/monopoly'><img src='//poggers.com/cdn/shop/t/132/assets//white-Monopoly.svg?94759' alt='monopoly' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<a href='/collections/avengers'><img src='//poggers.com/cdn/shop/t/132/assets//Avengers.svg?94759' alt='avengers' width='200' height='auto'/></a>");
                newMeganav08Collections.insertAdjacentHTML("beforeend", "<div class='bxshp_1'><div class='shopbtn'><a href='/collections/fandoms'>Shop All fandoms</a></div></div>");
            }
        }
    }

    // Append collection links to mega-nav (Manufacturers)
    const meganav09Collections = document.getElementById("meganav_09_collections");
    if (!meganav09Collections) {
        const targetElement = document.querySelector("#site-header-nav > nav.site-navigation > ul.navmenu > li:nth-child(9) .navmenu-meganav--desktop");
        if (targetElement) {
            targetElement.insertAdjacentHTML("beforeend", "<div id='meganav_09_collections'></div>");
            const newMeganav09Collections = document.getElementById("meganav_09_collections");
            if (newMeganav09Collections) {
               
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/bioworld'><img src='//poggers.com/cdn/shop/t/132/assets/Bioworld.svg?v=62506454778468797751728642798' alt='Bioworld Collection' width='200' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/wizards-of-the-coast'><img src='//poggers.com/cdn/shop/t/132/assets/Wizards-of-the-coast.svg?v=364044971755591351728642931' alt='Wizards of the Coast Collection' width='47' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mcfarlane-toys'><img src='//poggers.com/cdn/shop/t/132/assets/Mcfarlane-toys.svg?v=104441502495165623471728642816' alt='McFarlane Toys Collection' width='109' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/banpresto'><img src='//poggers.com/cdn/shop/t/132/assets/banpresto.svg?v=40958933942489297601728642839' alt='BANPRESTO Collection' width='150' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/abystyle'><img src='//poggers.com/cdn/shop/t/132/assets/ABYstyle.svg?v=84108083075720080001728642785' alt='ABYstyle Collection' width='75' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/kotobukiya'><img src='//poggers.com/cdn/shop/t/132/assets/Kotobukiya.svg?v=134134435200247417871728642812' alt='Kotobukiya Collection' width='75' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/eaglemoss'><img src='//poggers.com/cdn/shop/t/132/assets/Eaglemoss.svg?v=143664752419240807421728642806' alt='Eaglemoss Collection' width='112' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/great-eastern-entertainment'><img src='//poggers.com/cdn/shop/t/132/assets/great-eastern-entertainment.svg?v=67424990906297888121728642847' alt='Great Eastern Entertainment Collection' width='150' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/the-pokemon-company-international'><img src='//poggers.com/cdn/shop/t/132/assets/the-pokemon-company-international.svg?v=39999715015748100831728642928' alt='The pokemon company international' width='200' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/weta-workshop'><img src='//poggers.com/cdn/shop/t/132/assets/Weta-workshop.svg?v=45327749992067362591728642834' alt='Weta Workshop Collection' width='62' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/konami'><img src='//poggers.com/cdn/shop/t/132/assets/Konami.svg?v=182315273251784401371728642811' alt='Konami Collection' width='67' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/mega-bloks'><img src='//poggers.com/cdn/shop/t/132/assets/Mega-bloks.svg?v=123195507218788890271728642817' alt='Mega Bloks Collection' width='44' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/japanime-games'><img src='//poggers.com/cdn/shop/t/132/assets/Japanime-games.svg?v=166046910105281752781728642810' alt='Japanime Games Collection' width='41' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/jinx'><img src='//poggers.com/cdn/shop/t/132/assets/jinx.svg?v=59983067871140467281728642848' alt='Jinx Collection' width='200' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/little-buddy-usa'><img src='//poggers.com/cdn/shop/t/132/assets/Little-buddy-usa.svg?v=109233915571167425251728642813' alt='Little Buddy USA Collection' width='36' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/bethesda-softworks'><img src='//poggers.com/cdn/shop/t/132/assets/bethesda-softworks.svg?v=120575537759908381011728642840' alt='bethesda softworks' width='200' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/sega'><img src='//poggers.com/cdn/shop/t/132/assets/Sega.svg?v=147012398277622419921728642828' alt='Sega Collection' width='56' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<a href='/collections/ubisoft'><img src='//poggers.com/cdn/shop/t/132/assets/Ubisoft.svg?v=27107604004678682151728642833' alt='Ubisoft Collection' width='72' height='auto'/></a>");
                newMeganav09Collections.insertAdjacentHTML("beforeend", "<div class='bxshp_1'><div class='shopbtn'><a href='/collections/manufacturers'>Shop All Manufacturers</a></div></div>");
            }
        }
    }

    // Event listener for social sharing buttons (wishlist_share_bookmark_button)
    const wishlistShareButton1 = document.querySelector("#wishlist_share_bookmark_button > svg:nth-child(1)");
    if (wishlistShareButton1) {
        wishlistShareButton1.addEventListener("click", function() {
            const socialSharingButtons = document.getElementById("social-sharing-buttons");
            if (socialSharingButtons) {
                slideToggle(socialSharingButtons);
            }
        });
    }

    const wishlistShareButton2 = document.querySelector("#wishlist_share_bookmark_button > svg:nth-child(2)");
    if (wishlistShareButton2) {
        wishlistShareButton2.addEventListener("click", function() {
            const socialSharingButtonsMob = document.getElementById("social-sharing-buttons-mob");
            if (socialSharingButtonsMob) {
                slideToggle(socialSharingButtonsMob);
            }
        });
    }

    // Product quantity controls
    const quantitySelect = document.getElementById("product-quantity-select");
    const decreaseButton = document.getElementById("decrease_product_quantity");
    const increaseButton = document.getElementById("increase_product_quantity");

    if (decreaseButton && quantitySelect) {
        decreaseButton.addEventListener("click", function() {
            let currentQuantity = parseInt(quantitySelect.value);
            if (currentQuantity > 1) {
                quantitySelect.value = currentQuantity - 1;
                quantitySelect.dispatchEvent(new Event('change')); // Trigger change event
            }
        });
    }

    if (increaseButton && quantitySelect) {
        increaseButton.addEventListener("click", function() {
            let currentQuantity = parseInt(quantitySelect.value);
            const maxOption = quantitySelect.querySelector("option:last-child");
            if (maxOption) {
                const maxQuantity = parseInt(maxOption.value);
                if (currentQuantity < maxQuantity) {
                    quantitySelect.value = currentQuantity + 1;
                    quantitySelect.dispatchEvent(new Event('change')); // Trigger change event
                }
            }
        });
    }

    // Product gallery navigation (scroller buttons)
    const galleryScrollerButtons = document.querySelectorAll("#site-main > div.product--section > section.product--container > article.product--outer > div.product-gallery div.gallery-navigation--scroller + div > div > button");
    galleryScrollerButtons.forEach(button => {
        button.addEventListener("click", function() {
            const index = Array.from(this.parentNode.children).indexOf(this); // Get index of clicked button
            this.setAttribute("data-selected", "true");
            getSiblings(this).forEach(sibling => sibling.setAttribute("data-selected", "false"));

            const targetThumbnail = this.closest("div.product-gallery--navigation")?.querySelectorAll("button.product-gallery--media-thumbnail")[index];
            if (targetThumbnail) {
                targetThumbnail.click(); // Simulate click on corresponding media thumbnail
            }
        });
    });

    // Product gallery media thumbnails
    const mediaThumbnails = document.querySelectorAll("#site-main > div.product--section > section.product--container > article.product--outer > div.product-gallery button.product-gallery--media-thumbnail");
    mediaThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener("click", function() {
            const index = Array.from(this.parentNode.children).indexOf(this); // Get index of clicked thumbnail
            const targetButton = this.closest("div.product-gallery--navigation")?.querySelectorAll("button.product-gallery-thumbnail-button")[index];
            if (targetButton) {
                targetButton.setAttribute("data-selected", "true");
                getSiblings(targetButton).forEach(sibling => sibling.setAttribute("data-selected", "false"));
            }
        });
    });

    // Hide collection filters with only one item
    document.querySelectorAll("ul.collection-filters__filter").forEach(filterUl => {
        if (filterUl.children.length === 1) {
            const parentFilterGroup = filterUl.closest("div.filter-form");
            if (parentFilterGroup) {
                parentFilterGroup.style.display = 'none';
            }
        }
    });

    // Auto-click first visible filter group heading if first is hidden
    const firstFilterGroup = document.querySelector("div.collection-filters__filter-group:first-child");
    if (firstFilterGroup && isHidden(firstFilterGroup)) {
        const nextVisibleGroupHeading = getNextVisibleSibling(firstFilterGroup)?.querySelector("button.collection-filters__filter-group-heading");
        if (nextVisibleGroupHeading) {
            nextVisibleGroupHeading.click();
        }
    }

    // Returns page text modifications
    const returnsContainer = document.querySelector("#site-main > div.Esc-returns-container");
    if (returnsContainer) {
        const firstP = returnsContainer.querySelector("div:first-of-type > p:first-child");
        if (firstP) {
            firstP.textContent = "Need to return something? No problem. Just enter your email address or phone number and the order number.";
        }

        const emailLabel = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > label[for='email']");
        if (emailLabel) {
            emailLabel.textContent = "Email Address or Phone Number";
        }

        const emailInput = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > #email");
        if (emailInput) {
            emailInput.setAttribute("placeholder", "Your Email Address");
        }

        const orderNumberLabel = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > div.form-group > label[for='order_number']");
        if (orderNumberLabel) {
            orderNumberLabel.textContent = "Order Number";
        }

        const orderNumberInput = returnsContainer.querySelector("div:nth-of-type(3) > form.Esc-returns-form > div.form-group > #order_number");
        if (orderNumberInput) {
            orderNumberInput.setAttribute("placeholder", "Your Order Number");
        }

        returnsContainer.insertAdjacentHTML("afterbegin", "<figure id='returns-unicorn-wrapper'><img src='https://cdn.shopify.com/s/files/1/0400/9767/7479/files/returns-unicorn_456e9541-ef68-4918-bdcd-526293e76b42.svg?v=1662877434' alt='Poggers Returns Unicorn'></figure><h1 id='returns-page-title'>Returns</h1>");
    }

    // Contact message character counter
    const contactMessageInput = document.getElementById("contact_message");
    if (contactMessageInput) {
        const charCounter = document.getElementById("my_char_counter"); // Assuming this element exists
        if (charCounter) {
            contactMessageInput.addEventListener("keyup", function() {
                charCounter.textContent = this.value.length;
            });
        }
    }

    // Password visibility toggle
    document.querySelectorAll("img[src*='_password.svg']").forEach(img => {
        img.addEventListener("click", function() {
            const passwordInput = this.previousElementSibling;
            if (passwordInput && passwordInput.tagName === 'INPUT') { // Ensure it's an input
                const hideSrc = "//poggers.com/cdn/shop/t/132/assets/hide_password.svg?v=162480643263517671001728642848";
                const viewSrc = "//poggers.com/cdn/shop/t/132/assets/view_password.svg?v=116165601475903126981728642930";

                if (this.getAttribute("src").includes(viewSrc)) {
                    this.setAttribute("src", hideSrc);
                    passwordInput.setAttribute("type", "text");
                } else {
                    this.setAttribute("src", viewSrc);
                    passwordInput.setAttribute("type", "password");
                }
            }
        });
    });

    // Window resize event listener for placeholders
    window.addEventListener("resize", function() {
        changeSearchPlaceholder();
        changeNewsletterPlaceholder();
    });

    // Initial calls for placeholders on page load
    changeSearchPlaceholder();
    changeNewsletterPlaceholder();
});

// Loading screen hide on window load
// window.addEventListener("load", function() {


// ---------------------------------------------------------------------------
// Accessibility: Wishlist + Share icons
// - Gives every wishlist heart and share icon an accessible name + button role
// - Makes them reachable with Tab and operable with Enter / Space
// - Keeps aria-expanded on the Share icon in sync with its social panel
// - Adds a visible keyboard focus ring
// Markup on the product page (snippets/add-to-wishlist, share, product,
// product-gallery-navigation) already carries the attributes; this script
// covers the same icons wherever else they appear (recommendation cards,
// bundle block, late-inserted markup) and adds the keyboard behaviour.
// ---------------------------------------------------------------------------
(function () {
    'use strict';
    if (window.__pgA11yIconsBound) return;
    window.__pgA11yIconsBound = true;

    // 1) Visible focus ring (keyboard only)
    function injectFocusStyle() {
        if (document.getElementById('pg-a11y-icon-focus')) return;
        var style = document.createElement('style');
        style.id = 'pg-a11y-icon-focus';
        style.textContent =
            '.swym-add-to-wishlist[role="button"]:focus-visible,' +
            '[data-share-toggle]:focus-visible{' +
            'outline:2px solid #6C5DD3;outline-offset:2px;border-radius:50%;}' +
            '.swym-add-to-wishlist[role="button"]:focus:not(:focus-visible),' +
            '[data-share-toggle]:focus:not(:focus-visible){outline:none;}';
        document.head.appendChild(style);
    }

    // 2) Wishlist hearts
    function wishlistLabel(el) {
        var title = '';
        var p = el.parentElement;
        var t = p && (p.querySelector('.rec-pr') ||
            (p.nextElementSibling && p.nextElementSibling.querySelector &&
             p.nextElementSibling.querySelector('.rec-pr')));
        if (t) title = (t.textContent || '').trim();
        return title ? 'Add ' + title + ' to wishlist' : 'Add to wishlist';
    }

    function enhanceWishlist(el) {
        if (el.hasAttribute('data-a11y')) return;
        el.setAttribute('data-a11y', '1');

        // Inner heart inside an already-interactive wrapper: decorative only
        var outer = el.parentElement && el.parentElement.closest('.swym-add-to-wishlist');
        if (outer) {
            el.setAttribute('aria-hidden', 'true');
            el.setAttribute('focusable', 'false');
            el.removeAttribute('tabindex');
            return;
        }

        if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', wishlistLabel(el));
        // decorative <path> etc. inside an svg control need no announcement
        if (el.tagName && el.tagName.toLowerCase() === 'svg') {
            el.setAttribute('focusable', 'true');
        }
    }

    // 3) Share icon <-> panel state
    function sharePanelFor(icon) {
        var node = icon.closest('.product_wishlist_share') || icon.parentElement;
        for (var i = 0; i < 4 && node; i++) {
            var sib = node.nextElementSibling;
            if (sib && sib.classList && sib.classList.contains('product-share')) return sib;
            node = node.parentElement;
        }
        return null;
    }

    function syncExpanded(icon, panel) {
        var open = window.getComputedStyle(panel).display !== 'none';
        icon.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function enhanceShare(icon) {
        if (icon.hasAttribute('data-a11y')) return;
        icon.setAttribute('data-a11y', '1');
        if (!icon.hasAttribute('role')) icon.setAttribute('role', 'button');
        if (!icon.hasAttribute('tabindex')) icon.setAttribute('tabindex', '0');
        if (!icon.hasAttribute('aria-label')) icon.setAttribute('aria-label', 'Share this product');
        var panel = sharePanelFor(icon);
        if (panel) {
            syncExpanded(icon, panel);
            new MutationObserver(function () { syncExpanded(icon, panel); })
                .observe(panel, { attributes: true, attributeFilter: ['style'] });
        } else if (!icon.hasAttribute('aria-expanded')) {
            icon.removeAttribute('aria-expanded');
        }
    }

    function enhanceAll(root) {
        root = root || document;
        var i, list;
        list = root.querySelectorAll('.swym-add-to-wishlist:not([data-a11y])');
        for (i = 0; i < list.length; i++) enhanceWishlist(list[i]);
        list = root.querySelectorAll('[data-share-toggle]:not([data-a11y])');
        for (i = 0; i < list.length; i++) enhanceShare(list[i]);
    }

    // 4) Keyboard activation (Enter / Space) -> same handlers as a mouse click
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var t = e.target;
        if (!t || !t.closest) return;
        var control = t.closest('.swym-add-to-wishlist[role="button"], [data-share-toggle]');
        if (!control || control !== t) return;
        e.preventDefault(); // stop Space from scrolling the page
        var target = control.matches('[data-share-toggle]')
            ? control
            : (control.querySelector('.swym-add-to-wishlist') || control);
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });

    // 5) Init + watch for markup added later (AJAX cards, Swym, quick view)
    function init() {
        injectFocusStyle();
        enhanceAll(document);
        var queued = false;
        new MutationObserver(function () {
            if (queued) return;
            queued = true;
            requestAnimationFrame(function () { queued = false; enhanceAll(document); });
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// ---------------------------------------------------------------------------
// Accessibility: keyboard support for click-only <div>/<span> controls
// - Accordion headers (product page + article pages), popup/zoom close
//   buttons, the eye-injury-warning image trigger, the Globo sort-by
//   dropdown and "add a little something" cards were mouse-only (onclick on a non-interactive element).
// - Gives them role="button", tabindex="0", Enter/Space activation and,
//   for accordions, a synced aria-expanded state.
// - Runs on load and whenever markup is added later (AJAX, quick view).
// Visible focus comes from the global *:focus-visible ring in theme.liquid.
// ---------------------------------------------------------------------------
(function () {
    'use strict';
    if (window.__pgA11yClickControlsBound) return;
    window.__pgA11yClickControlsBound = true;

    var SELECTOR = [
        '.cst_accordion-header',
        '.aud_qar',
        '.somethin-item[onclick]',
        '.popup-close',
        '.mobile-zoom-close',
        '.eye-injury-warning',
        // Globo filter "Sort by" dropdown: toggle label + the sort options (<span onclick>)
        '.sort-by-toggle',
        '.globo-dropdown-custom__options span[data-sort]'
    ].join(',');

    function labelFor(el) {
        if (el.matches('.popup-close, .mobile-zoom-close')) return 'Close';
        if (el.matches('.eye-injury-warning')) return 'Eye injury warning \u2013 open larger view';
        return '';
    }

    function expandedState(el) {
        if (el.matches('.cst_accordion-header')) {
            var sec = el.closest('.accordion-section');
            return sec ? sec.classList.contains('open') : null;
        }
        if (el.matches('.aud_qar')) {
            var m = (el.getAttribute('onclick') || '').match(/toggleSection\((\d+)/);
            var c = m && document.getElementById('section' + m[1] + 'Content');
            return c ? c.style.display !== 'none' : null;
        }
        if (el.matches('.somethin-item')) return el.classList.contains('selected');
        return null;
    }

    function syncState(el) {
        var s = expandedState(el);
        if (s === null) return;
        el.setAttribute(el.matches('.somethin-item') ? 'aria-pressed' : 'aria-expanded', s ? 'true' : 'false');
    }

    function enhance(el) {
        if (el.getAttribute('data-a11y-click') === '1') { syncState(el); return; }
        el.setAttribute('data-a11y-click', '1');
        if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        var lbl = labelFor(el);
        if (lbl && !el.hasAttribute('aria-label') && !(el.textContent || '').trim().replace(/[\u00d7xX]/g, '')) {
            el.setAttribute('aria-label', lbl);
        } else if (lbl && !el.hasAttribute('aria-label') && el.matches('.popup-close, .mobile-zoom-close')) {
            el.setAttribute('aria-label', lbl);
        } else if (lbl && !el.hasAttribute('aria-label')) {
            el.setAttribute('aria-label', lbl);
        }
        syncState(el);
    }

    function enhanceAll(root) {
        var list = (root || document).querySelectorAll(SELECTOR);
        for (var i = 0; i < list.length; i++) enhance(list[i]);
    }

    // Enter / Space -> same handler as a mouse click
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var t = e.target;
        if (!t || !t.matches || !t.matches(SELECTOR)) return;
        e.preventDefault();
        t.click();
    });

    // Keep aria-expanded / aria-pressed in step after a click
    document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
        if (!t) return;
        setTimeout(function () { enhanceAll(document); }, 60);
    });

    function init() {
        enhanceAll(document);
        var queued = false;
        new MutationObserver(function () {
            if (queued) return;
            queued = true;
            requestAnimationFrame(function () { queued = false; enhanceAll(document); });
        }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
